import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';

import { TreeData } from '../../common/models';
import { KubaGeneralService } from './../../kuba-general.services';
import { BaseServices } from './../../kuba.services';
import { ManualService } from './manual.services';
import { BusinessServices } from '../../businesses/services/business.services';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ManualListResolver {
  constructor(private backend: ManualService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    let levelId = 0;
    let levelKey = 0;
    switch (BaseServices.UserRole) {
      case 'Admin':
        levelId = 1;
        levelKey = BaseServices.ApplicationId;
        break;
      case 'Portal':
        levelId = 2;
        levelKey = +BaseServices.PortalId;
        break;
      case 'Editor':
        levelId = 3;
        levelKey = BaseServices.BusinessId;
        break;
      case 'User':
        levelId = 3;
        levelKey = BaseServices.BusinessId;
        break;
      case 'Guest':
        levelId = 3;
        levelKey = BaseServices.BusinessId;
        break;
    }
    if (BaseServices.UserRole === 'Admin') {
      let resut: any = this.backend.getCommonManuallist(
        BaseServices.ApplicationId
      )!;
      return resut;
    } else if (BaseServices.UserRole === 'Portal') {
      let result: any = this.backend.getCommonManuallistByPortalLogin(
        +BaseServices.PortalId
      )!;
      return result;
    } else if (
      BaseServices.UserRole === 'Editor' ||
      BaseServices.UserRole === 'User' ||
      BaseServices.UserRole === 'Guest'
    ) {
      let result: any = this.backend.getCommonManuallistByBusinessLogin(
        BaseServices.BusinessId
      )!;
      return result;
    }
    return null!;
  }
}

@Injectable()
export class PortalManualListResolver {
  constructor(private backend: ManualService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    let levelId = 2; // Portal level
    if (BaseServices.UserRole === 'Admin') {
      return this.backend.getPortalManuallist(BaseServices.ApplicationId);
    }
    return null!;
  }
}

@Injectable()
export class BusinessManualListResolver {
  constructor(private backend: ManualService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    let levelId = 3; // Business level
    if (BaseServices.UserRole === 'Admin') {
      return this.backend.getBusinessManuallist(BaseServices.ApplicationId);
    }
    return null!;
  }
}

@Injectable()
export class AllManualListResolver {
  constructor(private backend: ManualService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    if (BaseServices.UserRole === 'Admin') {
      return this.backend.getAllManuallist(BaseServices.ApplicationId);
    }
    return null!;
  }
}

@Injectable()
export class ManualTreeDataResolver {
  constructor(
    private backend: ManualService,
    private businessService: BusinessServices
  ) {}

  /**
   * Resolves the tree for the manual
   * @param route Route with data necessary for the request
   * @returns Observable with a the manual's tree
   */
  resolve(route: ActivatedRouteSnapshot): Observable<TreeData[]> {
    let manualId = +route.params['mid'];
    let businessId = +route.params['mBusinessId'];
    let portalId = +route.params['mPortalId'];

    let userRole = BaseServices.UserRole;
    if (userRole === 'Admin') {
      return this.backend.getManualTree(manualId);
    }

    if (userRole === 'Portal') {
      return this.backend.getManualTreePortalLevel(manualId, portalId);
    }
    // Business level manual
    else {
      /*
        Gets portal Id in case of the business being in a portal.
        Portal Id does not seems to be known by the frontend, even if the business belongs to a portal
        */
      return this.businessService.getBusinessPortalId(businessId).pipe(
        switchMap(businessPortalId => {
          return this.backend.getManualTreeBusinessLevel(
            manualId,
            businessId,
            false
          );
        })
      );
    }
  }
}


@Injectable()
export class ChooseBusinessResolver {
  constructor(private kubaGeneralService: KubaGeneralService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<SelectItem[]> {
    return this.kubaGeneralService.getBusinessList();
  }
}


@Injectable()
export class BusinessModeReslover {
  constructor(private backend: ManualService) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (+BaseServices.roleId !== 1 && +BaseServices.roleId !== 2) {
      return this.backend.getBusinessMode(BaseServices.BusinessId);
    }
    return null!;
  }
}
@Injectable()
export class AdminUserResolver {
  constructor(private backend: ManualService) {}
  resolve() {
    if (+BaseServices.roleId === 1 || +BaseServices.roleId === 2) {
      return this.backend.getAdminUser();
    }
    return null!;
  }
}
